import axios from '@axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {},
  mutations: {
  },
  actions: {
    fetchAllSystemNotification({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/notification/system-notification')
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    readNotification(ctx, id) {
        return new Promise((resolve, reject) => {

            axios
                .put(`/api/notification/system-notification/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    },
    markAllAsRead({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/notification/markAllAsRead')
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
  },
}
